import { Accordion, Form, Button, Row, Col, Spinner } from 'react-bootstrap';
import { FaWrench, FaTimes, FaSave } from 'react-icons/fa';
import ColorPicker from './ColorPicker';
import { ChangeEvent } from 'react';

interface AppearanceConfigurationProps {
    primaryColor: string;
    setPrimaryColor: React.Dispatch<React.SetStateAction<string>>;
    avatarImage: string;
    setAvatarImage: (value: string) => void;
    launcherImage: string;
    setLauncherImage: (value: string) => void;
    selectedAvatarFile: File | null;
    setSelectedAvatarFile: (value: File | null) => void;
    selectedLauncherFile: File | null;
    setSelectedLauncherFile: (value: File | null) => void;
    handleAvatarFileChange: (e: ChangeEvent<HTMLInputElement>) => void;
    handleLauncherFileChange: (e: ChangeEvent<HTMLInputElement>) => void;
    agent: any;
    permission: boolean;
    isLoadingAvatar: boolean;
    isLoadingLauncher: boolean;
    onUpdateAppearance: () => void;
}

function AppearanceConfiguration({
    primaryColor,
    setPrimaryColor,
    avatarImage,
    setAvatarImage,
    launcherImage,
    setLauncherImage,
    selectedAvatarFile,
    setSelectedAvatarFile,
    selectedLauncherFile,
    setSelectedLauncherFile,
    handleAvatarFileChange,
    handleLauncherFileChange,
    agent,
    permission,
    isLoadingAvatar,
    isLoadingLauncher,
    onUpdateAppearance
}: AppearanceConfigurationProps) {
    return (
        <Accordion.Item eventKey="1" style={{ backgroundColor: '#2d2d2d', border: '1px solid #444', marginBottom: '1rem' }}>
            <Accordion.Header style={{ backgroundColor: '#2d2d2d' }}>
                <div className="d-flex align-items-center">
                    <div className="bg-info rounded p-2 me-3">
                        <FaWrench className="text-white" />
                    </div>
                    <div>
                        <span className="text-light fw-bold">Appearance</span>
                        <br />
                        <small style={{ color: '#999' }}>Customize colors and images</small>
                    </div>
                </div>
            </Accordion.Header>
            <Accordion.Body style={{ backgroundColor: '#2d2d2d' }}>
                <div className="mb-4">
                    <h6 className="text-light mb-3">Primary Color</h6>
                    <ColorPicker color={primaryColor} setColor={setPrimaryColor} />
                </div>

                <div className="mb-4">
                    <h6 className="text-light mb-3">Agent Avatar</h6>
                    <Row>
                        {avatarImage && (
                            <Col md={4} className="mb-3">
                                <div className="text-center">
                                    <img
                                        src={avatarImage}
                                        alt="avatar"
                                        style={{ 
                                            width: '60px', 
                                            height: '60px', 
                                            borderRadius: '50%',
                                            border: '2px solid #555'
                                        }}
                                    />
                                    <Button
                                        variant="outline-danger"
                                        size="sm"
                                        className="d-block mt-2 mx-auto"
                                        onClick={() => {
                                            setSelectedAvatarFile(null);
                                            setAvatarImage(agent.avatarImageURL || "");
                                        }}
                                    >
                                        <FaTimes />
                                    </Button>
                                </div>
                            </Col>
                        )}
                        <Col>
                            <Form.Group>
                                <Form.Label className="text-light">Upload Avatar</Form.Label>
                                <Form.Control
                                    type="file"
                                    accept='image/*'
                                    onChange={handleAvatarFileChange}
                                    style={{ 
                                        backgroundColor: '#1a1a1a', 
                                        borderColor: '#555',
                                        color: '#fff'
                                    }}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </div>

                <div className="mb-4">
                    <h6 className="text-light mb-3">Launcher Image</h6>
                    <Row>
                        {launcherImage && (
                            <Col md={4} className="mb-3">
                                <div className="text-center">
                                    <img
                                        src={launcherImage}
                                        alt="launcher"
                                        style={{ 
                                            width: '60px', 
                                            height: '60px', 
                                            borderRadius: '50%',
                                            border: '2px solid #555'
                                        }}
                                    />
                                    <Button
                                        variant="outline-danger"
                                        size="sm"
                                        className="d-block mt-2 mx-auto"
                                        onClick={() => {
                                            setSelectedLauncherFile(null);
                                            setLauncherImage(agent.launcherImageURL || "");
                                        }}
                                    >
                                        <FaTimes />
                                    </Button>
                                </div>
                            </Col>
                        )}
                        <Col>
                            <Form.Group>
                                <Form.Label className="text-light">Upload Launcher</Form.Label>
                                <Form.Control
                                    type="file"
                                    accept='image/*'
                                    onChange={handleLauncherFileChange}
                                    style={{ 
                                        backgroundColor: '#1a1a1a', 
                                        borderColor: '#555',
                                        color: '#fff'
                                    }}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </div>

                <div className="d-flex justify-content-end">
                    <Button
                        disabled={permission || (isLoadingAvatar || isLoadingLauncher)}
                        variant="primary"
                        onClick={onUpdateAppearance}
                        className="px-4"
                    >
                        {(isLoadingAvatar || isLoadingLauncher) ? (
                            <>
                                <Spinner as="span" animation="border" size="sm" className="me-2" />
                                Updating...
                            </>
                        ) : (
                            <>
                                <FaSave className="me-2" />
                                Update Appearance
                            </>
                        )}
                    </Button>
                </div>
            </Accordion.Body>
        </Accordion.Item>
    );
}

export default AppearanceConfiguration;